<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-2 mb-1">
                </div>
                <div class="col-md-10 mb-1 text-right">
                  <router-link
                    to="/pedidos"
                    class="btn btn-back mr-1"
                  >
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <span class="badge" :class="'badge-' + pedido.status_class">
                    {{ pedido.status_f }}
                  </span>
                </div>
                <div class="col-md-6">
                  <label>Data inicial</label>
                  <input type="date" class="form-control" v-model="pedido.data_inicio" disabled>
                </div>
                <div class="col-md-6">
                  <label>Data final</label>
                  <input type="date" class="form-control" v-model="pedido.data_fim" disabled>
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitante</label>
                  <v-select
                    v-model="pedido.unidade_solicitante"
                    class="vselect"
                    :options="unidades"
                    :reduce="(unidades) => unidades.id"
                    :label="'nome'"
                    disabled
                  />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitada</label>
                  <v-select
                    v-model="pedido.unidade_solicitada"
                    class="vselect"
                    :options="unidades"
                    :reduce="(unidades) => unidades.id"
                    :label="'nome'"
                    disabled
                  />
                </div>
                <div class="col-md-12">
                  <label>Observações</label>
                  <div class="row px-1">
                    <div class="col-md-12 p-1" style="border: 1px solid #ccc; border-radius: 8px;">
                      <div v-html="pedido.observacoes"></div>
                      <div v-if="!pedido.observacoes"><b>Não há observações</b></div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="col-md-8 mt-1"><b>Material</b></div>
                <div class="col-md-2 mt-1"><b>Solicitado</b></div>
                <div class="col-md-2 mt-1"><b>{{pedido.status === 0 ? "Atender" : "Atendido"}}</b></div>
                <div class="col-md-12 row p-0 m-0" id="lotes" v-for="(material_pedido, id) in pedido_material" :key="id">
                  <hr />
                  <div class="col-md-8 mt-1">{{material_pedido.material.nome}}</div>
                  <div class="col-md-2 mt-1">{{material_pedido.quantidade_solicitada}}</div>
                  <div class="col-md-2 mt-1" v-if="material_pedido.atendido">{{material_pedido.quantidade_atendida}}</div>
                  <div class="col-md-2 mt-1" v-else>Pedido não atendido</div>
                </div>
                <div class="col-md-12 mt-2">
                  <button class="btn btn-outline-primary btn-block" @click="redispensar()">Redispensar</button>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      pedido_material: [],
      pedido: {},
      unidades: [],
    };
  },
  computed: {},
  methods: {
    getPedidos: function (id) {
      const self = this;
      const api = self.$store.state.api + "pedidos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.pedido = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMaterialPedidos: function (id) {
      const self = this;
      const api = self.$store.state.api + `material_pedidos?paginated=false&pedido_id=${id}&with[]=material`;

      axios
        .get(api)
        .then((response) => {
          self.pedido_material = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    redispensar: function () {
      const self = this;
      const api = self.$store.state.api + `redispensar/${self.$route.params.id}`;

      axios
        .post(api)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getUnidades();
    
    if (id) {
      self.getPedidos(id);
      self.getMaterialPedidos(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
.badge-orange{
    background: #d34300;
    color: white;
  }
.badge-purple {
  background: #880088;
  color: white;
}
</style>